import { render, staticRenderFns } from "./AvukatPicker.vue?vue&type=template&id=49932956&scoped=true"
import script from "./AvukatPicker.vue?vue&type=script&lang=ts"
export * from "./AvukatPicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49932956",
  null
  
)

export default component.exports